import { SolvTheme, Stack } from '@solvhealth/jigsaw-v1';
import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { isNativeApp } from '../../../../core/util/device';
import { biggerThan } from '../../../../core/util/styledComponents';
import useSetTitle from '../../../../hooks/useSetTitle';
import useToggle from '../../../../hooks/useToggle';
import ProfileCard from '../../../Account/Profile/ProfileCard';
import SolvSnackBar from '../../../SolvPatternLibrary/SnackBar';
import { MobileBottomSpacing } from '../../constants/styles';
import useSelectUserProfile from '../../hooks/useSelectUserProfile';
import Root from '../Root';
import SwimLanes from '../SwimLanes';
import { CategoryIds } from '../SwimLanes/util/tileEnums';
import useSelectHandleCropSave from './hooks/useSelectHandleCropSave';
import useSelectSearchPharmacy from './hooks/useSelectSearchPharmacy';
import useSelectUpdateUserProcessing from './hooks/useSelectUpdateUserProcessing';
import useSelectUpdateUserProfile from './hooks/useSelectUpdateUserProfile';

const BigLanes = styled(SwimLanes).withConfig({ componentId: 'sc-d69ap3-0' })`
  overflow-x: scroll;
  overflow-y: hidden;
  padding-bottom: 12px;
  padding-x: ${SolvTheme.space[2]};
`;

const ProfileContainer = styled.div.withConfig({ componentId: 'sc-d69ap3-1' })`
  padding: 12px 16px 24px;
  max-width: 600px;
  ${biggerThan.sm`
    padding: 12px 32px 24px;
  `}
`;

type Props = {
  params?: any;
};

const Profile = (props: Props) => {
  const { params } = props;
  const { userProfileId } = params;
  const userProfile = useSelectUserProfile(params.userProfileId);
  const userProfilePhoto = useSelector((state: any) => state.userProfilePhoto);
  const [snackbarOpen, toggleSnackbar] = useToggle();

  const handleCropSave = useSelectHandleCropSave(userProfileId);
  const updateUserProfile = useSelectUpdateUserProfile();
  const updateUserProfileProcessing = useSelectUpdateUserProcessing();
  const searchPharmacies = useSelectSearchPharmacy();

  useSetTitle(`${userProfile.first_name ? `${userProfile.first_name}'s ` : ''}Profile`);

  return (
    <Root>
      <Stack maxWidth={SolvTheme.breakpoints.lg} mx="auto" pb={6} pt={3} space={4}>
        <BigLanes categoryIds={[CategoryIds.HEALTH_CHECKLIST]} userProfile={userProfile} />

        <ProfileContainer>
          <ProfileCard
            handleCropSave={handleCropSave}
            openSnackBar={toggleSnackbar}
            searchPharmacies={searchPharmacies}
            updateUserProfile={updateUserProfile}
            updateUserProfileProcessing={updateUserProfileProcessing}
            userProfile={userProfile}
            userProfilePhoto={userProfilePhoto}
          />

          <SolvSnackBar
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            onClose={toggleSnackbar}
            open={snackbarOpen}
          >
            Profile updated!
          </SolvSnackBar>
        </ProfileContainer>

        {isNativeApp() && <MobileBottomSpacing />}
      </Stack>
    </Root>
  );
};

export default Profile;
